import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  onZoomIn: () => void
  onZoomOut: () => void
}

const ZoomButtons: FC<Props> = ({ onZoomIn, onZoomOut }) => {
  return (
    <div className="absolute right-[25px] top-[25px] z-[2] grid grid-flow-row gap-y-2">
      <button
        onClick={onZoomIn}
        className={cn(
          'z-[2] flex h-8 w-8 items-center justify-center rounded-full border-none bg-shade-800 text-white outline-none transition-all duration-150',
          'lg:h-10 lg:w-10',
          'hover:bg-rolexPrimary',
        )}
      >
        <svg height="11" width="11" viewBox="0 0 11 11" fill="currentColor">
          <path d="m11 6.15h-4.85v4.85h-1.3v-4.85h-4.85v-1.3h4.85v-4.85h1.3v4.85h4.85z" />
        </svg>
      </button>
      <button
        onClick={onZoomOut}
        className={cn(
          'z-[2] flex h-8 w-8 items-center justify-center rounded-full border-none bg-shade-800 text-white outline-none transition-all duration-150',
          'lg:h-10 lg:w-10',
          'hover:bg-rolexPrimary',
        )}
      >
        <svg height="11" width="11" viewBox="0 0 11 11" fill="currentColor">
          <path d="m0 6.5v-1h11v1z" />
        </svg>
      </button>
    </div>
  )
}

export default ZoomButtons
